import { sanitizeSubscriptionFeatures } from "../config/helpers";

export const getSupplierPlan = (state) => {
  return sanitizeSubscriptionFeatures({
    ...state.appGlobal.subscription.subscription,
  });
};
